import React from 'react';

import { assertUnreachableOrReturnDefault } from 'src/lib/assertUnreachable';
import { ProposalStatus } from 'src/lib/graphqlTypes/types';

export const ProposalStatusDescription = ({
  status,
}: {
  status: ProposalStatus;
}) => {
  switch (status) {
    case ProposalStatus.DRAFT:
      return (
        <>
          This proposal is a <span className="font-semibold">draft</span>.
          Reviewers will not be notified until its status is changed to{' '}
          <span className="font-semibold">open for feedback.</span>
        </>
      );
    case ProposalStatus.OPEN:
      return (
        <>
          <span className="mb-6 inline-block">
            This proposal is{' '}
            <span className="font-semibold">open for feedback</span>. It will
            become approved once it meets your team's minimum number of
            approvals. It will become{' '}
            <span className="font-semibold">implemented</span> once its changes
            are published.
          </span>
          <br />
          Authors and reviewers can close and reopen a proposal at any time.
        </>
      );
    case ProposalStatus.APPROVED:
      return (
        <>
          <span className="mb-6 inline-block">
            This proposal is <span className="font-semibold">approved</span>.
          </span>
          <br />
          Authors and reviewers can close and reopen a proposal at any time.
        </>
      );
    case ProposalStatus.CLOSED:
      return (
        <>
          This proposal is <span className="font-semibold">closed</span>.
          Authors and reviewers can close and reopen a proposal at any time.
        </>
      );
    case ProposalStatus.IMPLEMENTED:
      return (
        <>
          This proposal has been{' '}
          <span className="font-semibold">implemented</span>.
        </>
      );
    default:
      return assertUnreachableOrReturnDefault(
        status,
        <>This proposal's status is unknown.</>,
      );
  }
};
